module.exports = __webpack_public_path__ + "static/media/battles-tooltip-2.7ef42eba.png";